import { post, postFile, postExFile } from "@utils/httpUtil";

// 医生邀请-手机号校验
export function inviteRecordCheckByPhone(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/inviteRecord/v2/checkByPhone`, data, config);
}

//站内医生- 医生名称检索列表
export function doctorFindDoctorByName(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/findDoctorByName`, data, config);
}

//站内医生-根据mc
export function inviteRecordCheckByDoctorId(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/inviteRecord/v2/checkByDoctorId`, data, config);
}

// 邀请医生 - 导入表格_手机号码和姓名;
export function inviteRecordDoctorInviteImport(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postFile(`/c/pc/community/doctor/inviteRecord/v2/doctorInviteImport`, data, config);
}

// 医生邀请-新建邀约;
export function inviteRecordBatchAdd(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/inviteRecord/v2/batchAdd`, data, config);
}

export function inviteRecordInviteDoctorUrl(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/inviteRecord/v2/inviteDoctorUrl`, data, config);
}

export function inviteRecordGetInviteDoctorTxt(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/inviteRecord/v2/getInviteDoctorTxt`, data, config);
}
export function findByCommunityIdDefault(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/revenueDistributionModelConfig/findByCommunityIdDefault`, data, config);
}
export function inviteRecordSaveInviteDoctorTxt(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/inviteRecord/v2/saveInviteDoctorTxt`, data, config);
}

export function inviteRecordGetPlatformInviteDoctorTxt(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/inviteRecord/v2/getPlatformInviteDoctorTxt`, data, config);
}

export function inviteRecordSavePlatformInviteDoctorTxt(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/inviteRecord/v2/savePlatformInviteDoctorTxt`, data, config);
}

//邀请记录信息
export function inviteRecordGetPage(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/inviteRecord/v2/page`, data, config);
}

// 医生邀请 - 再次邀请;
export function inviteRecordInviteAgain(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/inviteRecord/v2/inviteAgain`, data, config);
}

export function inviteRecordFindDoctorInviteRecodes(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/inviteRecord/v2/findDoctorInviteRecodes`, data, config);
}

//邀请记录信息
export function auditRecordGetPageInfo(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/auditRecord/v2/getPageInfo`, data, config);
}

//邀请记录信息
export function auditRecordExportData(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/c/pc/community/doctor/auditRecord/v2/exportData`, data, config);
}

export function auditRecordAudit(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/auditRecord/v2/audit`, data, config);
}

// 社区医生认证记录列表
export function v2findAuditRecodes(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/v2/findAuditRecodes`, data, config);
}
// saas-医生邀约-认证记录-详情
export function getDoctorAuthenticationDetail(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/v2/getDoctorAuthenticationDetail`, data, config);
}

// 社区医生认证记录列表导出
export function v2exportAuditRecodes(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/c/pc/community/doctor/v2/exportAuditRecodes`, data, config);
}

// 社区医生认证记录数据统计
export function v2getAuditStatistics(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/v2/getAuditStatistics`, data, config);
}

// 医生注册认证进度--查询分享数据配置
export function getQueryLimitConfig(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/getQueryLimitConfig`, data, config);
}

// 医生注册认证进度--保存分享数据配置
export function newCommunitySaveOrUpdateQueryLimitConfig(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/saveOrUpdateQueryLimitConfig`, data, config);
}

// 查询其他认证是否显示
export function findOtherAuthenticatedIsShow(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/findOtherAuthenticatedIsShow`, data, config);
}

// 查询社区医生加入社区自动审核开关配置
export function getAutoAuditSwitchConfig(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/auditRecord/autoAudit/getSwitchConfig`, data, config);
}

// 修改社区医生加入社区自动审核开关配置
export function updateAutoAuditSwitchConfig(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/auditRecord/autoAudit/updateSwitchConfig`, data, config);
}

// 查询社区医生加入社区自动审核规则配置
export function getAutoAuditGetRuleConfig(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/auditRecord/autoAudit/getRuleConfig`, data, config);
}

// 修改社区医生加入社区自动审核规则配置
export function updateAutoAuditRuleConfig(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/auditRecord/autoAudit/updateRuleConfig`, data, config);
}
// 根据关键词搜索医院列表
export function getHospitalByKeyWord(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`${process.env.VUE_APP_DOC_WENWO_LINK}/middle-sp/basic/hospital/getHospitalByKeyWord`, data, config);
}
// 查询医院的别名
export function groupFndAliasHospital(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`${process.env.VUE_APP_DOC_WENWO_LINK}/middle-sp/hospital/store/group/findAliasHospital`, data, config);
}
// 创建医院别名反馈工单
export function groupFeedbackCreate(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`${process.env.VUE_APP_DOC_WENWO_LINK}/middle-sp/hospital/store/group/feedback/create`, data, config);
}

import * as httpUtil from "@/utils/httpUtil";

const interfaces: Array<Record<string, any>> = [
  {
    method: "post",
    name: "findSassCommunityDoctorSeat",
    url: "/c/pc/community/doctor/findSassCommunityDoctorSeat",
    desc: "查询社区医生席位信息",
  },
  {
    method: "post",
    name: "pageList",
    url: "/c/pc/community/budgetAccount/pageList",
    desc: "分页查询预算账户列表",
  },
  {
    method: "post",
    name: "confirmRelationDoctorSeat",
    url: "/c/pc/community/budgetAccount/confirmRelationDoctorSeat",
    desc: "预算账户-确认关联医生席位",
  },
  {
    method: "post",
    name: "incomeAndExpenseDetailPageList",
    url: "/c/pc/community/budgetAccount/detail/incomeAndExpenseDetailPageList",
    desc: "预算账户明细-收支明细",
  },
  {
    method: "post",
    name: "incomeAndExpenseDetailPageList",
    url: "/c/pc/community/budgetAccount/detail/incomeAndExpenseDetailPageList",
    desc: "预算账户明细-收支明细",
  },
  {
    method: "post",
    name: "findSaasCommunityDoctorDataStatistics",
    url: "/c/pc/community/doctor/findSaasCommunityDoctorDataStatistics",
    desc: "查询社区医生数据统计",
  },
  { method: "post", name: "getPageInfo", url: "/c/pc/community/doctor/v2/getPageInfo", desc: "分页查询" },
];

function exportsRender(interfacesArr: Array<Record<string, any>>) {
  const resultExports: Record<string, any> = {};
  interfacesArr.map((item: Record<string, any>) => {
    resultExports[item.name] = (data: Record<string | number, any>) => {
      return (httpUtil as Record<string, any>)[item.method](item.url, data, item.config);
    };
  });
  return resultExports;
}

export const doctorInvite = exportsRender(interfaces);
